<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <vs-tabs>
              <vs-tab label="Tickets">
                <div class="con-tab-ejemplo" id="report_cont">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Inicio" v-model="inicioTickets" /></div>
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Fin" class="inputx" v-model="finTickets" /></div>
                          <div style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="getListTicketsDate()" color="primary" type="filled">Consultar</vs-button>
                          </div>
                          <div v-if="reportTickets" style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportList" color="primary" type="filled">Exportar</vs-button>
                          </div>
                          <div v-if="reportTickets" style="align-self: flex-end; text-align: center;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportToPDF" color="primary" type="filled">PDF</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportTickets" style="padding-top: 20px;">
                        <div class="row col-md-12">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Tickets:</p>
                                <h4 class="card-title">{{ lengthTickets }}</h4>
                                <h4 class="card-title">$ {{ new Intl.NumberFormat("de-DE").format(totalTickets) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-delivery-fast text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Creados/En Ejecucion:</p>
                                <h4 class="card-title">{{ lengthTicketsOther }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalTicketsOther) }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Finalizados:</p>
                                <h4 class="card-title">{{ lengthTicketsFinished }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalTicketsFinished)
                                  }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Cancelados:</p>
                                <h4 class="card-title">{{ lengthTicketsCanceled }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalTicketsCanceled)
                                  }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-12">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChart.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de ordenes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Creado/En Ejecucion
                                  <i class="fa fa-circle text-success"></i> Finalizados
                                  <i class="fa fa-circle text-danger"></i> Cancelados
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportTickets" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <table1 class="table-hover table-striped" :columns="table1.columns" :data="table1.data">
                        </table1>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Comprobantes">
                <div class="con-tab-ejemplo">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Inicio" v-model="inicioVouchers" /></div>
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Fin" class="inputx" v-model="finVouchers" /></div>
                          <div class="col-xl-3 col-md-3">
                            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Dependencia"
                              v-model="dependenceVoucher">
                              <vs-select-item :key="index" :value="item.value" :text="item.text"
                                v-for="item, index in optionsVoucherDependence" />
                            </vs-select>
                          </div>
                          <div style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="getListDateVouchers()" color="primary" type="filled">Consultar</vs-button>
                          </div>
                          <div v-if="reportVoucher" style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportListVoucher" color="primary" type="filled">Exportar</vs-button>
                          </div>
                          <div v-if="reportVoucher" style="align-self: flex-end; text-align: center;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportToPDF" color="primary" type="filled">PDF</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportVoucher" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Comprobantes:</p>
                                <h4 class="card-title">{{ lengthVouchers }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalVouchers) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-watch-time text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Pendiente:</p>
                                <h4 class="card-title">{{ lengthVouchersPending }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalVoucherPending) }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Aprobado:</p>
                                <h4 class="card-title">{{ lengthVouchersApproved }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalVoucherApproved)
                                  }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Declinado:</p>
                                <h4 class="card-title">{{ lengthVouchersDeclined }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalVoucherDeclined)
                                  }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartVouchers.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de Comprobantes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Pendiente
                                  <i class="fa fa-circle text-success"></i> Aprobado
                                  <i class="fa fa-circle text-danger"></i> Declinado
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportVoucher" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <table1 class="table-hover table-striped" :columns="table2.columns" :data="table2.data">
                        </table1>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Conductores">
                <div class="con-tab-ejemplo">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Inicio" v-model="inicioDrivers" /></div>
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Fin" class="inputx" v-model="finDrivers" /></div>
                          <div class="col-xl-3 col-md-3">
                            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Conductor"
                              v-model="driver">
                              <vs-select-item :key="index" :value="item.text" :text="item.text"
                                v-for="item, index in optionsDriver" />
                            </vs-select>
                          </div>
                          <div style="align-self: flex-end;" class="col-auto">
                            <vs-button v-if="driver" style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="getListDateDrivers()" color="primary" type="filled">Consultar</vs-button>
                          </div>
                          <div v-if="reportTicketsDrivers" style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportListDriver" color="primary" type="filled">Exportar</vs-button>
                          </div>
                          <div v-if="reportTicketsDrivers" style="align-self: flex-end; text-align: center;"
                            class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportToPDF" color="primary" type="filled">PDF</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportTicketsDrivers"
                        style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Tickets:</p>
                                <h4 class="card-title">{{ lengthTicketsDrivers }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalTicketsDrivers) }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-watch-time text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Creados/En Ejecucion:</p>
                                <h4 class="card-title">{{ lengthTicketsDriversOther }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDriversOther) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Finalizado:</p>
                                <h4 class="card-title">{{ lengthTicketsDriversFinished }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDriversFinished) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Cancelado:</p>
                                <h4 class="card-title">{{ lengthTicketsDriversCanceled }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDriversCanceled) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartTicketsDrivers.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de ordenes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Creado/En Ejecucion
                                  <i class="fa fa-circle text-success"></i> Finalizados
                                  <i class="fa fa-circle text-danger"></i> Cancelados
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportTicketsDrivers"
                        style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <table1 class="table-hover table-striped" :columns="table3.columns" :data="table3.data">
                        </table1>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Vehículos">
                <div class="con-tab-ejemplo">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Inicio" v-model="inicioVehicles" /></div>
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Fin" class="inputx" v-model="finVehicles" /></div>
                          <div class="col-xl-2 col-md-2">
                            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Vehículo"
                              v-model="vehicle">
                              <vs-select-item :key="index" :value="item.text" :text="item.text"
                                v-for="item, index in optionsVehicle" />
                            </vs-select>
                          </div>
                          <div style="align-self: flex-end; text-align: center;" class="col-auto">
                            <vs-button v-if="vehicle" style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="getListDateVehicles()" color="primary" type="filled">Consultar</vs-button>
                          </div>
                          <div v-if="reportTicketsVehicles" style="align-self: flex-end; text-align: center;"
                            class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportListVehicle" color="primary" type="filled">Exportar</vs-button>
                          </div>
                          <div v-if="reportTicketsVehicles" style="align-self: flex-end; text-align: center;"
                            class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportToPDF" color="primary" type="filled">PDF</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportTicketsVehicles"
                        style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Tickets:</p>
                                <h4 class="card-title">{{ lengthTicketsVehicles }}</h4>
                                <h4 class="card-title">${{ new Intl.NumberFormat("de-DE").format(totalTicketsVehicles)
                                  }}
                                </h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-watch-time text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Creados/En Ejecucion:</p>
                                <h4 class="card-title">{{ lengthTicketsVehiclesOther }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsVehiclesOther) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Finalizado:</p>
                                <h4 class="card-title">{{ lengthTicketsVehiclesFinished }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsVehiclesFinished) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Cancelado:</p>
                                <h4 class="card-title">{{ lengthTicketsVehiclesCanceled }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsVehiclesCanceled) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartTicketsVehicles.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de ordenes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Creado/En Ejecucion
                                  <i class="fa fa-circle text-success"></i> Finalizados
                                  <i class="fa fa-circle text-danger"></i> Cancelados
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportTicketsVehicles"
                        style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <table1 class="table-hover table-striped" :columns="table4.columns" :data="table4.data">
                        </table1>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <!--<vs-tab label="Centros de costo">
                <div class="con-tab-ejemplo">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-3 col-md-3"><vs-input style="height: auto !important;" type="date" label="Inicio" v-model="inicioCostCenter"/></div>
                          <div class="col-xl-3 col-md-3"><vs-input style="height: auto !important;" type="date" label="Fin" class="inputx" v-model="finCostCenter"/></div>
                          <div class="col-xl-3 col-md-3">
                            <vs-select class="selectExample" placeholder="Seleccionar" label="Vehículo" v-model="costCenter">
                              <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="item,index in optionsCostCenter" />
                            </vs-select>
                          </div>
                          <div style="align-self: flex-end;" class="col-xl-3 col-md-3">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;" @click="getListTicketsCostCenterDate()" color="primary" type="filled">Consultar</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportCostCenter" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Tickets:</p>
                                <h4 class="card-title">{{lengthTicketsCostCenter}}</h4>
                                <h4 class="card-title">$ {{new Intl.NumberFormat("de-DE").format(totalTicketsCostCenter)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-delivery-fast text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Creados/En Ejecucion:</p>
                                <h4 class="card-title">{{lengthTicketsCostCenterOther}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalTicketsCostCenterOther)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Finalizados:</p>
                                <h4 class="card-title">{{lengthTicketsCostCenterFinished}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalTicketsCostCenterFinished)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Cancelados:</p>
                                <h4 class="card-title">{{lengthTicketsCostCenterCanceled}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalTicketsCostCenterCanceled)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartTicketsCostCenter.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de ordenes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Creado/En Ejecucion
                                  <i class="fa fa-circle text-success"></i> Finalizados
                                  <i class="fa fa-circle text-danger"></i> Cancelados
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportCostCenter" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Comprobantes:</p>
                                <h4 class="card-title">{{lengthVouchersCostCenter}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalVouchersCostCenter)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-watch-time text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Pendiente:</p>
                                <h4 class="card-title">{{lengthVouchersCostCenterPending}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalVoucherCostCenterPending)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Aprobado:</p>
                                <h4 class="card-title">{{lengthVouchersCostCenterApproved}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalVoucherCostCenterApproved)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Declinado:</p>
                                <h4 class="card-title">{{lengthVouchersCostCenterDeclined}}</h4>
                                <h4 class="card-title">${{new Intl.NumberFormat("de-DE").format(totalVoucherCostCenterDeclined)}}</h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartVouchersCostCenter.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de Comprobantes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Pendiente
                                  <i class="fa fa-circle text-success"></i> Aprobado
                                  <i class="fa fa-circle text-danger"></i> Declinado
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>-->
              <vs-tab label="Dependencias">
                <div class="con-tab-ejemplo">
                  <div class="row">
                    <div class="col-12">
                      <template class="header">
                        <div class="row">
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Inicio" v-model="inicioDependence" /></div>
                          <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date"
                              label="Fin" class="inputx" v-model="finDependence" /></div>
                          <div class="col-xl-3 col-md-3">
                            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Dependencia"
                              v-model="dependence">
                              <vs-select-item :key="index" :value="item.text" :text="item.text"
                                v-for="item, index in optionsDependence" />
                            </vs-select>
                          </div>
                          <div style="align-self: flex-end;" class="col-auto">
                            <vs-button v-if="dependence" style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="getListTicketsDependenceDate()" color="primary"
                              type="filled">Consultar</vs-button>
                          </div>
                          <div v-if="reportDependence" style="align-self: flex-end;" class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportListDependence" color="primary" type="filled">Exportar</vs-button>
                          </div>
                          <div v-if="reportDependence" style="align-self: flex-end; text-align: center;"
                            class="col-auto">
                            <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                              @click="exportToPDF" color="primary" type="filled">PDF</vs-button>
                          </div>
                        </div>
                      </template>
                      <div v-if="reportDependence" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <div class="row col-md-8">
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-warning">
                                <i class="nc-icon nc-single-copy-04 text-info"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Tickets:</p>
                                <h4 class="card-title">{{ lengthTicketsDependence }}</h4>
                                <h4 class="card-title">$ {{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDependence) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-delivery-fast text-warning"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Creados/En Ejecucion:</p>
                                <h4 class="card-title">{{ lengthTicketsDependenceOther }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDependenceOther) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-success">
                                <i class="nc-icon nc-check-2 text-success"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Finalizados:</p>
                                <h4 class="card-title">{{ lengthTicketsDependenceFinished }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDependenceFinished) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header" class="icon-danger">
                                <i class="nc-icon nc-simple-remove text-danger"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Cancelados:</p>
                                <h4 class="card-title">{{ lengthTicketsDependenceCanceled }}</h4>
                                <h4 class="card-title">${{ new
                                  Intl.NumberFormat("de-DE").format(totalTicketsDependenceCanceled) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div v-if="dependence == 'Contado'" class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header">
                                <i class="nc-icon nc-money-coins"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Efectivo:</p>
                                <h4 class="card-title"><i class="nc-icon nc-check-2 text-success"></i>({{
                                  lengthTicketsDependenceFinishedEfectivo }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceFinishedEfectivo) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-delivery-fast text-warning"></i>({{
                                  lengthTicketsDependenceOtherEfectivo }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceOtherEfectivo) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-simple-remove text-danger"></i>({{
                                  lengthTicketsDependenceCanceledEfectivo }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceCanceledEfectivo) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div v-if="dependence == 'Contado'" class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header">
                                <i class="nc-icon nc-grid-45"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">QR:</p>
                                <h4 class="card-title"><i class="nc-icon nc-check-2 text-success"></i>({{
                                  lengthTicketsDependenceFinishedQR }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceFinishedQR) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-delivery-fast text-warning"></i>({{
                                  lengthTicketsDependenceOtherQR }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceOtherQR) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-simple-remove text-danger"></i>({{
                                  lengthTicketsDependenceCanceledQR }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceCanceledQR) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                          <div v-if="dependence == 'Contado'" class="col-xl-6 col-md-6">
                            <stats-card>
                              <div slot="header">
                                <i class="nc-icon nc-bank"></i>
                              </div>
                              <div slot="content">
                                <p class="card-category">Transferencia:</p>
                                <h4 class="card-title"><i class="nc-icon nc-check-2 text-success"></i>({{
                                  lengthTicketsDependenceFinishedTransfer }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceFinishedTransfer) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-delivery-fast text-warning"></i>({{
                                  lengthTicketsDependenceOtherTransfer }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceOtherTransfer) }}</h4>
                                <h4 class="card-title"><i class="nc-icon nc-simple-remove text-danger"></i>({{
                                  lengthTicketsDependenceCanceledTransfer }}):${{ new
                                    Intl.NumberFormat("de-DE").format(totalTicketsDependenceCanceledTransfer) }}</h4>
                              </div>
                            </stats-card>
                          </div>
                        </div>
                        <div class="row col-md-5">
                          <div class="col-md-12">
                            <chart-card :chart-data="pieChartTicketsDependence.data" chart-type="Pie">
                              <template slot="header">
                                <h4 class="card-title">Estadisticas</h4>
                                <p class="card-category">Estado de ordenes</p>
                              </template>
                              <template slot="footer">
                                <div class="legend">
                                  <i class="fa fa-circle text-warning"></i> Creado/En Ejecucion
                                  <i class="fa fa-circle text-success"></i> Finalizados
                                  <i class="fa fa-circle text-danger"></i> Cancelados
                                </div>
                                <hr>
                                <div class="stats">
                                  <i class="fa fa-clock-o"></i> Rango seleccionado
                                </div>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="reportDependence" style="padding-top: 20px; display: flex; align-items: flex-start;">
                        <table1 class="table-hover table-striped" :columns="table5.columns" :data="table5.data">
                        </table1>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import ChartCard from 'src/components/Cards/ChartCard.vue'
const tableColumns = ['Numero', 'Dependencia', 'Conductor', 'Vehículo', 'Cliente', 'Valor', 'Estado', 'Fecha']
const tableColumns2 = ['Numero', 'Dependencia', 'Observaciones', 'Valor', 'Estado', 'Fecha']
import Table1 from 'src/components/TableTicketsReports.vue'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

export default {
  components: {
    Card,
    ChartCard,
    StatsCard,
    Table1
  },
  data() {
    return {
      inicioTickets: '',
      finTickets: '',
      inicioVouchers: '',
      finVouchers: '',
      dependenceVoucher: null,
      inicioDrivers: '',
      finDrivers: '',
      inicioVehicles: '',
      finVehicles: '',
      inicioCostCenter: '',
      finCostCenter: '',
      inicioDependence: '',
      finDependence: '',
      filter: 10,
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      tickets: [],
      totalTickets: 0,
      lengthTicketsDependenceFinishedTransfer: 0,
      totalTicketsDependenceFinishedTransfer: 0,
      lengthTicketsDependenceOtherTransfer: 0,
      totalTicketsDependenceOtherTransfer: 0,
      lengthTicketsDependenceCanceledTransfer: 0,
      totalTicketsDependenceCanceledTransfer: 0,
      lengthTicketsDependenceFinishedEfectivo: 0,
      totalTicketsDependenceFinishedEfectivo: 0,
      lengthTicketsDependenceOtherEfectivo: 0,
      totalTicketsDependenceOtherEfectivo: 0,
      lengthTicketsDependenceCanceledEfectivo: 0,
      totalTicketsDependenceCanceledEfectivo: 0,
      lengthTicketsDependenceFinishedQR: 0,
      totalTicketsDependenceFinishedQR: 0,
      lengthTicketsDependenceOtherQR: 0,
      totalTicketsDependenceOtherQR: 0,
      lengthTicketsDependenceCanceledQR: 0,
      totalTicketsDependenceCanceledQR: 0,
      lengthTicketsDependenceEfectivo: 0,
      totalTicketsDependenceEfectivo: 0,
      lengthTicketsDependenceQR: 0,
      totalTicketsDependenceQR: 0,
      lengthTickets: 0,
      lengthTicketsFinished: 0,
      lengthTicketsCanceled: 0,
      lengthTicketsOther: 0,
      lengthVouchers: 0,
      lengthVouchersPending: 0,
      lengthVouchersApproved: 0,
      lengthVouchersDeclined: 0,
      totalVouchers: 0,
      lengthTicketsDrivers: 0,
      lengthTicketsDriversFinished: 0,
      lengthTicketsDriversCanceled: 0,
      lengthTicketsDriversOther: 0,
      totalTicketsDrivers: 0,
      lengthTicketsVehicles: 0,
      lengthTicketsVehiclesFinished: 0,
      lengthTicketsVehiclesCanceled: 0,
      lengthTicketsVehiclesOther: 0,
      totalTicketsVehicles: 0,
      totalTicketsCostCenter: 0,
      lengthTicketsCostCenter: 0,
      lengthTicketsCostCenterFinished: 0,
      lengthTicketsCostCenterCanceled: 0,
      lengthTicketsCostCenterOther: 0,
      lengthVouchersCostCenter: 0,
      lengthVouchersCostCenterPending: 0,
      lengthVouchersCostCenterApproved: 0,
      lengthVouchersCostCenterDeclined: 0,
      totalVouchersCostCenter: 0,
      totalTicketsDependence: 0,
      lengthTicketsDependence: 0,
      lengthTicketsDependenceFinished: 0,
      lengthTicketsDependenceCanceled: 0,
      lengthTicketsDependenceOther: 0,
      lengthVouchersDependence: 0,
      lengthVouchersDependencePending: 0,
      lengthVouchersDependenceApproved: 0,
      lengthVouchersDependenceDeclined: 0,
      totalVouchersDependence: 0,
      driver: null,
      vehicle: null,
      costCenter: null,
      dependence: null,
      reportTickets: false,
      reportVoucher: false,
      reportTicketsDrivers: false,
      reportTicketsVehicles: false,
      reportCostCenter: false,
      reportDependence: false,
      pieChart: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartVouchers: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartTicketsDrivers: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartTicketsVehicles: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartTicketsCostCenter: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartVouchersCostCenter: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartTicketsDependence: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      pieChartVouchersDependence: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      optionsDriver: [],
      optionsVehicle: [],
      optionsCostCenter: [],
      optionsVoucherDependence: [{ text: 'Todos', value: 10 }],
      optionsDependence: [],
      table1: {
        columns: [...tableColumns],
        data: []
      },
      table2: {
        columns: [...tableColumns2],
        data: []
      },
      table3: {
        columns: [...tableColumns],
        data: []
      },
      table4: {
        columns: [...tableColumns],
        data: []
      },
      table5: {
        columns: [...tableColumns],
        data: []
      },
    }
  },
  methods: {
    exportToPDF() {
      window.print();
    },
    getListTicketsDate() {
      this.reportTickets = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      this.axios.get(serverUrl + '/api/getListTicketsDateV2/' + this.id_company + '/' + this.inicioTickets + '/' + this.finTickets + '/' + this.filter)
        .then(res => {
          if (res.data.status == 200) {
            this.tickets = res.data.tickets;
            this.table1.data = res.data.tickets;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalTickets = 0;
            this.totalTicketsFinished = 0;
            this.totalTicketsCanceled = 0;
            this.totalTicketsOther = 0;
            this.lengthTicketsFinished = 0;
            this.lengthTicketsCanceled = 0;
            this.lengthTicketsOther = 0;
            this.tickets.forEach((d) => {
              this.totalTickets += parseFloat(d.total);
              if (d.status == 3) {
                this.lengthTicketsFinished += 1;
                this.totalTicketsFinished += parseFloat(d.total);
              }
              if (d.status == 4) {
                this.lengthTicketsCanceled += 1;
                this.totalTicketsCanceled += parseFloat(d.total);
              }
              if (d.status == 1 || d.status == 2) {
                this.lengthTicketsOther += 1;
                this.totalTicketsOther += parseFloat(d.total);
              }
            });
            this.lengthTickets = this.tickets.length;
            this.pieChart.data.labels = [];
            this.pieChart.data.series = [];
            this.pieChart.data.labels.push(' ');
            this.pieChart.data.series.push('');
            this.chartLabelCanceled = (this.lengthTicketsCanceled / this.lengthTickets) * 100;
            this.pieChart.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChart.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthTicketsOther / this.lengthTickets) * 100;
            this.pieChart.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChart.data.series.push(this.chartLabelCreated);
            this.pieChart.data.labels.push(' ');
            this.pieChart.data.series.push('');
            this.chartLabelFinished = (this.lengthTicketsFinished / this.lengthTickets) * 100;
            this.pieChart.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChart.data.series.push(this.chartLabelFinished);
            this.reportTickets = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListDateVouchers() {
      this.reportVoucher = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      const dependenceVoucher = this.dependenceVoucher ? this.dependenceVoucher : '10';
      this.axios.get(serverUrl + '/api/getListDateVouchers/' + this.id_company + '/' + this.inicioVouchers + '/' + this.finVouchers + '/10/' + dependenceVoucher)
        .then(res => {
          if (res.data.status == 200) {
            this.vouchers = res.data.comprobantes;
            this.table2.data = res.data.comprobantes;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalVouchers = 0;
            this.totalVoucherPending = 0;
            this.totalVoucherApproved = 0;
            this.totalVoucherDeclined = 0;
            this.lengthVouchersPending = 0;
            this.lengthVouchersApproved = 0;
            this.lengthVouchersDeclined = 0;
            this.lengthVouchers = this.vouchers.length;
            this.vouchers.forEach((d) => {
              this.totalVouchers += parseFloat(d.total);
              if (d.status == 1) {
                this.lengthVouchersPending += 1;
                this.totalVoucherPending += parseFloat(d.total);
              }
              if (d.status == 2) {
                this.lengthVouchersApproved += 1;
                this.totalVoucherApproved += parseFloat(d.total);
              }
              if (d.status == 3) {
                this.lengthVouchersDeclined += 1;
                this.totalVoucherDeclined += parseFloat(d.total);
              }
            });
            this.pieChartVouchers.data.labels = [];
            this.pieChartVouchers.data.series = [];
            this.pieChartVouchers.data.labels.push(' ');
            this.pieChartVouchers.data.series.push('');
            this.chartLabelCanceled = (this.lengthVouchersDeclined / this.lengthVouchers) * 100;
            this.pieChartVouchers.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartVouchers.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthVouchersPending / this.lengthVouchers) * 100;
            this.pieChartVouchers.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartVouchers.data.series.push(this.chartLabelCreated);
            this.pieChartVouchers.data.labels.push(' ');
            this.pieChartVouchers.data.series.push('');
            this.chartLabelFinished = (this.lengthVouchersApproved / this.lengthVouchers) * 100;
            this.pieChartVouchers.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartVouchers.data.series.push(this.chartLabelFinished);
            this.reportVoucher = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListDateVouchers');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListDateVouchers:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListDateDrivers() {
      this.reportTicketsDrivers = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      this.axios.get(serverUrl + '/api/getListDateDrivers/' + this.id_company + '/' + this.inicioDrivers + '/' + this.finDrivers + '/' + this.driver)
        .then(res => {
          if (res.data.status == 200) {
            this.ticketsDrivers = res.data.ticketsDrivers;
            this.table3.data = res.data.ticketsDrivers;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalTicketsDrivers = 0;
            this.totalTicketsDriversOther = 0;
            this.totalTicketsDriversFinished = 0;
            this.totalTicketsDriversCanceled = 0;
            this.lengthTicketsDriversFinished = 0;
            this.lengthTicketsDriversCanceled = 0;
            this.lengthTicketsDriversOther = 0;
            this.lengthTicketsDrivers = this.ticketsDrivers.length;
            this.ticketsDrivers.forEach((d) => {
              this.totalTicketsDrivers += parseFloat(d.total);
              if (d.status == 3) {
                this.lengthTicketsDriversFinished += 1;
                this.totalTicketsDriversFinished += parseFloat(d.total);
              }
              if (d.status == 4) {
                this.lengthTicketsDriversCanceled += 1;
                this.totalTicketsDriversCanceled += parseFloat(d.total);
              }
              if (d.status == 1 || d.status == 2) {
                this.lengthTicketsDriversOther += 1;
                this.totalTicketsDriversOther += parseFloat(d.total);
              }
            });
            this.pieChartTicketsDrivers.data.labels = [];
            this.pieChartTicketsDrivers.data.series = [];
            this.pieChartTicketsDrivers.data.labels.push(' ');
            this.pieChartTicketsDrivers.data.series.push('');
            this.chartLabelCanceled = (this.lengthTicketsDriversCanceled / this.lengthTicketsDrivers) * 100;
            this.pieChartTicketsDrivers.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartTicketsDrivers.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthTicketsDriversOther / this.lengthTicketsDrivers) * 100;
            this.pieChartTicketsDrivers.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartTicketsDrivers.data.series.push(this.chartLabelCreated);
            this.pieChartTicketsDrivers.data.labels.push(' ');
            this.pieChartTicketsDrivers.data.series.push('');
            this.chartLabelFinished = (this.lengthTicketsDriversFinished / this.lengthTicketsDrivers) * 100;
            this.pieChartTicketsDrivers.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartTicketsDrivers.data.series.push(this.chartLabelFinished);
            this.reportTicketsDrivers = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListDateDrivers');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListDateDrivers:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListDateVehicles() {
      this.reportTicketsVehicles = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      this.axios.get(serverUrl + '/api/getListDateVehicles/' + this.id_company + '/' + this.inicioVehicles + '/' + this.finVehicles + '/' + this.vehicle)
        .then(res => {
          if (res.data.status == 200) {
            this.ticketsVehicles = res.data.ticketsVehicles;
            this.table4.data = res.data.ticketsVehicles;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalTicketsVehicles = 0;
            this.totalTicketsVehiclesOther = 0;
            this.totalTicketsVehiclesFinished = 0;
            this.totalTicketsVehiclesCanceled = 0;
            this.lengthTicketsVehiclesFinished = 0;
            this.lengthTicketsVehiclesCanceled = 0;
            this.lengthTicketsVehiclesOther = 0;
            this.lengthTicketsVehicles = this.ticketsVehicles.length;
            this.ticketsVehicles.forEach((d) => {
              this.totalTicketsVehicles += parseFloat(d.total);
              if (d.status == 3) {
                this.lengthTicketsVehiclesFinished += 1;
                this.totalTicketsVehiclesFinished += parseFloat(d.total);
              }
              if (d.status == 4) {
                this.lengthTicketsVehiclesCanceled += 1;
                this.totalTicketsVehiclesCanceled += parseFloat(d.total);
              }
              if (d.status == 1 || d.status == 2) {
                this.lengthTicketsVehiclesOther += 1;
                this.totalTicketsVehiclesOther += parseFloat(d.total);
              }
            });
            this.pieChartTicketsVehicles.data.labels = [];
            this.pieChartTicketsVehicles.data.series = [];
            this.pieChartTicketsVehicles.data.labels.push(' ');
            this.pieChartTicketsVehicles.data.series.push('');
            this.chartLabelCanceled = (this.lengthTicketsVehiclesCanceled / this.lengthTicketsVehicles) * 100;
            this.pieChartTicketsVehicles.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartTicketsVehicles.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthTicketsVehiclesOther / this.lengthTicketsVehicles) * 100;
            this.pieChartTicketsVehicles.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartTicketsVehicles.data.series.push(this.chartLabelCreated);
            this.pieChartTicketsVehicles.data.labels.push(' ');
            this.pieChartTicketsVehicles.data.series.push('');
            this.chartLabelFinished = (this.lengthTicketsVehiclesFinished / this.lengthTicketsVehicles) * 100;
            this.pieChartTicketsVehicles.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartTicketsVehicles.data.series.push(this.chartLabelFinished);
            this.reportTicketsVehicles = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListDateVehicles');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListDateVehicles:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListTicketsCostCenterDate() {
      this.reportCostCenter = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      this.axios.get(serverUrl + '/api/getListTicketsCostCenterDate/' + this.id_company + '/' + this.inicioCostCenter + '/' + this.finCostCenter + '/' + this.costCenter)
        .then(res => {
          if (res.data.status == 200) {
            this.tickets = res.data.ticketsCostCenter;
            this.vouchers = res.data.vouchersCostCenter;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalTicketsCostCenter = 0;
            this.totalTicketsCostCenterFinished = 0;
            this.totalTicketsCostCenterCanceled = 0;
            this.totalTicketsCostCenterOther = 0;
            this.lengthTicketsCostCenterFinished = 0;
            this.lengthTicketsCostCenterCanceled = 0;
            this.lengthTicketsCostCenterOther = 0;
            this.tickets.forEach((d) => {
              this.totalTicketsCostCenter += parseFloat(d.total);
              if (d.status == 3) {
                this.lengthTicketsCostCenterFinished += 1;
                this.totalTicketsCostCenterFinished += parseFloat(d.total);
              }
              if (d.status == 4) {
                this.lengthTicketsCostCenterCanceled += 1;
                this.totalTicketsCostCenterCanceled += parseFloat(d.total);
              }
              if (d.status == 1 || d.status == 2) {
                this.lengthTicketsCostCenterOther += 1;
                this.totalTicketsCostCenterOther += parseFloat(d.total);
              }
            });
            this.lengthTicketsCostCenter = this.tickets.length;
            this.pieChartTicketsCostCenter.data.labels = [];
            this.pieChartTicketsCostCenter.data.series = [];
            this.pieChartTicketsCostCenter.data.labels.push(' ');
            this.pieChartTicketsCostCenter.data.series.push('');
            this.chartLabelCanceled = (this.lengthTicketsCostCenterCanceled / this.lengthTicketsCostCenter) * 100;
            this.pieChartTicketsCostCenter.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartTicketsCostCenter.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthTicketsCostCenterOther / this.lengthTicketsCostCenter) * 100;
            this.pieChartTicketsCostCenter.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartTicketsCostCenter.data.series.push(this.chartLabelCreated);
            this.pieChartTicketsCostCenter.data.labels.push(' ');
            this.pieChartTicketsCostCenter.data.series.push('');
            this.chartLabelFinished = (this.lengthTicketsCostCenterFinished / this.lengthTicketsCostCenter) * 100;
            this.pieChartTicketsCostCenter.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartTicketsCostCenter.data.series.push(this.chartLabelFinished);
            this.totalVouchersCostCenter = 0;
            this.totalVoucherCostCenterPending = 0;
            this.totalVoucherCostCenterApproved = 0;
            this.totalVoucherCostCenterDeclined = 0;
            this.lengthVouchersCostCenterPending = 0;
            this.lengthVouchersCostCenterApproved = 0;
            this.lengthVouchersCostCenterDeclined = 0;
            this.lengthVouchersCostCenter = this.vouchers.length;
            this.vouchers.forEach((d) => {
              this.totalVouchersCostCenter += parseFloat(d.total);
              if (d.status == 1) {
                this.lengthVouchersCostCenterPending += 1;
                this.totalVoucherCostCenterPending += parseFloat(d.total);
              }
              if (d.status == 2) {
                this.lengthVouchersCostCenterApproved += 1;
                this.totalVoucherCostCenterApproved += parseFloat(d.total);
              }
              if (d.status == 3) {
                this.lengthVouchersCostCenterDeclined += 1;
                this.totalVoucherCostCenterDeclined += parseFloat(d.total);
              }
            });
            this.pieChartVouchersCostCenter.data.labels = [];
            this.pieChartVouchersCostCenter.data.series = [];
            this.pieChartVouchersCostCenter.data.labels.push(' ');
            this.pieChartVouchersCostCenter.data.series.push('');
            this.chartLabelCanceled = (this.lengthVouchersCostCenterDeclined / this.lengthVouchersCostCenter) * 100;
            this.pieChartVouchersCostCenter.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartVouchersCostCenter.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthVouchersCostCenterPending / this.lengthVouchersCostCenter) * 100;
            this.pieChartVouchersCostCenter.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartVouchersCostCenter.data.series.push(this.chartLabelCreated);
            this.pieChartVouchersCostCenter.data.labels.push(' ');
            this.pieChartVouchersCostCenter.data.series.push('');
            this.chartLabelFinished = (this.lengthVouchersCostCenterApproved / this.lengthVouchersCostCenter) * 100;
            this.pieChartVouchersCostCenter.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartVouchersCostCenter.data.series.push(this.chartLabelFinished);
            this.reportCostCenter = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListTicketsDependenceDate() {
      this.reportDependence = false;
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Consultando..."
      })
      this.axios.get(serverUrl + '/api/getListTicketsDependenceDate/' + this.id_company + '/' + this.inicioDependence + '/' + this.finDependence + '/' + this.dependence)
        .then(res => {
          if (res.data.status == 200) {
            this.tickets = res.data.ticketsDependence;
            this.table5.data = res.data.ticketsDependence;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.totalTicketsDependence = 0;
            this.totalTicketsDependenceEfectivo = 0;
            this.totalTicketsDependenceQR = 0;
            this.totalTicketsDependenceFinished = 0;
            this.totalTicketsDependenceCanceled = 0;
            this.totalTicketsDependenceOther = 0;
            this.lengthTicketsDependenceEfectivo = 0;
            this.lengthTicketsDependenceQR = 0;
            this.lengthTicketsDependenceFinished = 0;
            this.lengthTicketsDependenceCanceled = 0;
            this.lengthTicketsDependenceOther = 0;
            this.lengthTicketsDependenceFinishedEfectivo = 0;
            this.totalTicketsDependenceFinishedEfectivo = 0;
            this.lengthTicketsDependenceOtherEfectivo = 0;
            this.totalTicketsDependenceOtherEfectivo = 0;
            this.lengthTicketsDependenceCanceledEfectivo = 0;
            this.totalTicketsDependenceCanceledEfectivo = 0;
            this.lengthTicketsDependenceFinishedQR = 0;
            this.totalTicketsDependenceFinishedQR = 0;
            this.lengthTicketsDependenceOtherQR = 0;
            this.totalTicketsDependenceOtherQR = 0;
            this.lengthTicketsDependenceCanceledQR = 0;
            this.totalTicketsDependenceCanceledQR = 0;
            this.lengthTicketsDependenceFinishedTransfer = 0;
            this.totalTicketsDependenceFinishedTransfer = 0;
            this.lengthTicketsDependenceOtherTransfer = 0;
            this.totalTicketsDependenceOtherTransfer = 0;
            this.lengthTicketsDependenceCanceledTransfer = 0;
            this.totalTicketsDependenceCanceledTransfer = 0;
            this.tickets.forEach((d) => {
              this.totalTicketsDependence += parseFloat(d.total);
              if (d.way_to_pay == 'Efectivo') {
                this.lengthTicketsDependenceEfectivo += 1;
                this.totalTicketsDependenceEfectivo += parseFloat(d.total);
              }
              if (d.way_to_pay == 'QR') {
                this.lengthTicketsDependenceQR += 1;
                this.totalTicketsDependenceQR += parseFloat(d.total);
              }
              if (d.way_to_pay == 'Transferencia') {
                this.lengthTicketsDependenceTransfer += 1;
                this.totalTicketsDependenceTransfer += parseFloat(d.total);
              }
              if (d.status == 3) {
                this.lengthTicketsDependenceFinished += 1;
                this.totalTicketsDependenceFinished += parseFloat(d.total);
                if (d.way_to_pay == 'Efectivo') {
                  this.lengthTicketsDependenceFinishedEfectivo += 1;
                  this.totalTicketsDependenceFinishedEfectivo += parseFloat(d.total);
                }
                if (d.way_to_pay == 'QR') {
                  this.lengthTicketsDependenceFinishedQR += 1;
                  this.totalTicketsDependenceFinishedQR += parseFloat(d.total);
                }
                if (d.way_to_pay == 'Transferencia') {
                  this.lengthTicketsDependenceFinishedTransfer += 1;
                  this.totalTicketsDependenceFinishedTransfer += parseFloat(d.total);
                }
              }
              if (d.status == 4) {
                this.lengthTicketsDependenceCanceled += 1;
                this.totalTicketsDependenceCanceled += parseFloat(d.total);
                if (d.way_to_pay == 'Efectivo') {
                  this.lengthTicketsDependenceCanceledEfectivo += 1;
                  this.totalTicketsDependenceCanceledEfectivo += parseFloat(d.total);
                }
                if (d.way_to_pay == 'QR') {
                  this.lengthTicketsDependenceCanceledQR += 1;
                  this.totalTicketsDependenceCanceledQR += parseFloat(d.total);
                }
                if (d.way_to_pay == 'Transferencia') {
                  this.lengthTicketsDependenceCanceledTransfer += 1;
                  this.totalTicketsDependenceCanceledTransfer += parseFloat(d.total);
                }
              }
              if (d.status == 1 || d.status == 2) {
                this.lengthTicketsDependenceOther += 1;
                this.totalTicketsDependenceOther += parseFloat(d.total);
                if (d.way_to_pay == 'Efectivo') {
                  this.lengthTicketsDependenceOtherEfectivo += 1;
                  this.totalTicketsDependenceOtherEfectivo += parseFloat(d.total);
                }
                if (d.way_to_pay == 'QR') {
                  this.lengthTicketsDependenceOtherQR += 1;
                  this.totalTicketsDependenceOtherQR += parseFloat(d.total);
                }
                if (d.way_to_pay == 'Transferencia') {
                  this.lengthTicketsDependenceOtherTransfer += 1;
                  this.totalTicketsDependenceOtherTransfer += parseFloat(d.total);
                }
              }
            });
            this.lengthTicketsDependence = this.tickets.length;
            this.pieChartTicketsDependence.data.labels = [];
            this.pieChartTicketsDependence.data.series = [];
            this.pieChartTicketsDependence.data.labels.push(' ');
            this.pieChartTicketsDependence.data.series.push('');
            this.chartLabelCanceled = (this.lengthTicketsDependenceCanceled / this.lengthTicketsDependence) * 100;
            this.pieChartTicketsDependence.data.labels.push(parseInt(this.chartLabelCanceled) + '%');
            this.pieChartTicketsDependence.data.series.push(this.chartLabelCanceled);
            this.chartLabelCreated = (this.lengthTicketsDependenceOther / this.lengthTicketsDependence) * 100;
            this.pieChartTicketsDependence.data.labels.push(parseInt(this.chartLabelCreated) + '%');
            this.pieChartTicketsDependence.data.series.push(this.chartLabelCreated);
            this.pieChartTicketsDependence.data.labels.push(' ');
            this.pieChartTicketsDependence.data.series.push('');
            this.chartLabelFinished = (this.lengthTicketsDependenceFinished / this.lengthTicketsDependence) * 100;
            this.pieChartTicketsDependence.data.labels.push(parseInt(this.chartLabelFinished) + '%');
            this.pieChartTicketsDependence.data.series.push(this.chartLabelFinished);
            this.reportDependence = true;
            this.$vs.loading.close();
          } else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListDrivers() {
      this.axios.get(serverUrl + '/api/getListActiveDrivers/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.drivers.forEach(detail => {
              let driver = { text: detail.name, value: detail.name };
              this.optionsDriver.push(driver);
            });
          } else {
            console.log('Error getListDrivers');
          }
        })
        .catch(err => {
          console.log('Error getListDrivers');
        });
    },
    getListVehicle() {
      this.axios.get(serverUrl + '/api/getListActiveVehicle/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.vehicles.forEach(detail => {
              let vehicle = { text: detail.placa, value: detail.placa };
              this.optionsVehicle.push(vehicle);
            });
          } else {
            console.log('Error getListVehicle');
          }
        })
        .catch(err => {
          console.log('Error getListVehicle');
        });
    },
    getListCostCenter() {
      this.axios.get(serverUrl + '/api/getListActiveCostCenter/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.costCenters.forEach(detail => {
              this.costCenter = { text: detail.name, value: detail.name };
              this.optionsCostCenter.push(this.costCenter);
            });
          } else {
            console.log('Error getListCostCenter');
          }
        })
        .catch(err => {
          console.log('Error getListCostCenter');
        });
    },
    getListDependence() {
      this.axios.get(serverUrl + '/api/getListActiveDependence/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.dependences.forEach(detail => {
              let dependence = { text: detail.name, value: detail.name };
              this.optionsDependence.push(dependence);
              this.optionsVoucherDependence.push(dependence);
            });
          } else {
            console.log('Error getListDependence');
          }
        })
        .catch(err => {
          console.log('Error getListDependence');
        });
    },
    exportList() {
      let url = `${serverUrl}/api/exportList/${this.id_company}/${this.inicioTickets}/${this.finTickets}`;
      window.open(url, '_blank');
    },
    exportListDriver() {
      let url = `${serverUrl}/api/exportListDriver/${this.id_company}/${this.inicioDrivers}/${this.finDrivers}/${this.driver}`;
      window.open(url, '_blank');
    },
    exportListDependence() {
      let url = `${serverUrl}/api/exportListDependence/${this.id_company}/${this.inicioDependence}/${this.finDependence}/${this.dependence}`;
      window.open(url, '_blank');
    },
    exportListVoucher() {
      let url = `${serverUrl}/api/exportListVoucher/${this.id_company}/${this.inicioVouchers}/${this.finVouchers}`;
      window.open(url, '_blank');
    },
    exportListVehicle() {
      let url = `${serverUrl}/api/exportListVehicle/${this.vehicle}/${this.inicioVehicles}/${this.finVehicles}`;
      window.open(url, '_blank');
    }
  },
  created() {
    const date = new Date();
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const anio = date.getFullYear();
    this.inicioTickets = `${anio}-${mes}-${dia}`;
    this.finTickets = `${anio}-${mes}-${dia}`;
    this.inicioVouchers = `${anio}-${mes}-${dia}`;
    this.finVouchers = `${anio}-${mes}-${dia}`;
    this.inicioDrivers = `${anio}-${mes}-${dia}`;
    this.finDrivers = `${anio}-${mes}-${dia}`;
    this.inicioVehicles = `${anio}-${mes}-${dia}`;
    this.finVehicles = `${anio}-${mes}-${dia}`;
    this.inicioCostCenter = `${anio}-${mes}-${dia}`;
    this.finCostCenter = `${anio}-${mes}-${dia}`;
    this.inicioDependence = `${anio}-${mes}-${dia}`;
    this.finDependence = `${anio}-${mes}-${dia}`;
  },
  mounted() {
    this.getListDrivers();
    this.getListVehicle();
    //this.getListCostCenter();
    this.getListDependence();
  }
}
</script>
<style></style>
